import { useEffect, useRef } from "react";
import Modal from "../common/modals";

interface PointItem {
  action: string;
  points: number;
}

export default function LeaderPointsCriteria({
  onClose,
}: {
  onClose: () => void;
}) {
  const modalRef = useRef<HTMLDivElement>(null);

  const pointsList: PointItem[] = [
    {
      action: "Adding tags upon post creation",
      points: 1,
    },
    {
      action: "Voting on a poll",
      points: 1,
    },
    {
      action: "Answering a quiz",
      points: 1,
    },
    {
      action: "Like a post",
      points: 5,
    },
    {
      action: "Get Likes on Comment",
      points: 10,
    },
    {
      action: "Open app once a day",
      points: 10,
    },
    {
      action: "Get likes on your post",
      points: 20,
    },
    {
      action: "Vote on Poll",
      points: 25,
    },
    {
      action: "Answer on QNA",
      points: 25,
    },
    {
      action: "Get comments on Post",
      points: 25,
    },
    {
      action: "Reply on Question",
      points: 25,
    },
    {
      action: "Marked as Best Answers",
      points: 25,
    },
    {
      action: "Opening the app for a 7-day week",
      points: 35,
    },
  ];

  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Modal
      isOpen={true}
      size="medium"
      variant="middle"
      customClass="max-w-lg "
      closeOnOverlayClick={true}
      parentCustomClass="top-0"
      customVariant="top-[65%]"
    >
      <div ref={modalRef}>
        <h2 className="text-[20px] font-semibold border-b px-6 py-4">
          Leader points criteria
        </h2>

        <div className="p-6 space-y-3">
          {pointsList.map((item, index) => (
            <div
              key={index}
              className="flex justify-between items-center border-b pb-2"
            >
              <span className="text-[15px] text-black font-semibold">
                {item.action}
              </span>
              <span className="flex items-center gap-1 text-[15px] font-semibold ">
                {item.points}
                <img
                  src="/assets/icons/star-red.png"
                  alt=""
                  className="ml-2 md:w-4 md:h-4 w-3 h-3"
                />
              </span>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
